module.exports = __webpack_public_path__ + "img/1536279428.ba359aba.jpg";